import BrowserPage from './BrowserPage.vue'
export default BrowserPage
